import { combineReducers } from 'redux'
import auth from './auth'
import userAuth from './userAuth'
import base from './base'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        auth,
        userAuth,
        base,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
